import gql from 'graphql-tag';

export const GET_JOHARI_USER = gql`
  query GetJohariUser($_id: ID!) {
    getJohariUser(_id: $_id) {
      _id
      firstName
      avatar
      birthDate
      fingerprints
      gender
    }
  }
`;

export const GET_CODE_BY_USER_ID = gql`
  query GetCodeByUserId($userId: ID!) {
    getCodeByUserId(userId: $userId) {
      _id
      code
      ownerId
      ownerName
      codeType
      usedCount
    }
  }
`;
